/* Generated by tools/build_sections.py from brand/quote.js.
   Edit there, not here. */
(function(){if(window.__efEnergy_quote)return;window.__efEnergy_quote=1;
/* EcoFlow Home Energy — the quote funnel.
 *
 * Three questions, a contact step, a confirmation. Every state ships as
 * MARKUP: render_design.js renders each one and build_patterns.py emits them
 * as sibling [data-qstate] panels, so this file switches panels and carries
 * the answers between them. It never builds a screen.
 *
 * WHERE THE ENQUIRY GOES
 * The operator has no lead endpoint yet, so the container carries
 * data-q-endpoint="" and the funnel hands off to the sales WhatsApp number,
 * which is monitored today. When an endpoint is configured the same submit
 * POSTs instead. It must never point at EcoFlow's central lead system: a lead
 * from this site belongs to the operator who does the survey and the install
 * (foundations/enquiry-funnel.md §2).
 *
 * CONSENT
 * The box ships UNTICKED (build_patterns.untick_consent) and its real value is
 * what travels. The reference hard-sets optIn:true whatever the viewer chose;
 * under PDPA that is not consent, and it is not what this does.
 *
 * NOTHING IS PERSISTED while the form is being filled. No localStorage, and
 * no sessionStorage: a half-filled form holds a name, a phone number and a bill
 * band, and leaving that on a shared machine is a worse failure than retyping
 * four answers. The one exception is the submit itself: Shopify only accepts a
 * real page POST, so the confirmation's slots (reference, phone, state, bill,
 * picks; never name, email or notes) cross the redirect in one sessionStorage
 * key that resume() deletes as it reads it.
 */
(function () {
  "use strict";

  var doc = document;
  var root = doc.querySelector("[data-qstate]");
  if (!root) return;
  root = root.parentNode;

  var panels = root.querySelectorAll("[data-qstate]");
  if (!panels.length) return;

  var PICKS = ["interest", "property", "solar"];     // Q_STEPS order
  var answers = { picks: {}, fields: {}, consent: false };
  var step = 0;
  var LAST = PICKS.length;                           // the contact step's index

  function panel(name) {
    return root.querySelector('[data-qstate="' + name + '"]');
  }

  function show(name) {
    Array.prototype.forEach.call(panels, function (p) {
      p.hidden = p.getAttribute("data-qstate") !== String(name);
    });
    /* Moving to a new question is a change of context, so say so rather than
       leaving a screen reader on the old heading. */
    var now = panel(name);
    if (now) {
      var h = now.querySelector("h2");
      if (h) {
        h.setAttribute("tabindex", "-1");
        h.focus({ preventScroll: true });
      }
      window.scrollTo({ top: 0, behavior: "auto" });
    }
  }

  /* ----------------------------------------------------------- answers */
  doc.addEventListener("click", function (e) {
    var tile = e.target.closest ? e.target.closest("[data-qpick]") : null;
    if (tile && root.contains(tile)) {
      e.preventDefault();
      answers.picks[PICKS[step]] = tile.getAttribute("data-qpick");
      step = Math.min(LAST, step + 1);
      show(step);
      return;
    }
    var hook = e.target.closest ? e.target.closest("[data-eh]") : null;
    if (!hook || !root.contains(hook)) return;
    var a = hook.getAttribute("data-eh");
    if (a === "q-back")    { e.preventDefault(); step = Math.max(0, step - 1); show(step); }
    if (a === "q-submit")  { e.preventDefault(); submit(); }
    if (a === "q-restart") { e.preventDefault(); reset(); }
  });

  function onField(e) {
    var el = e.target;
    if (el.hasAttribute && el.hasAttribute("data-q")) {
      answers.fields[el.getAttribute("data-q")] = el.value;
    } else if (el.getAttribute && el.getAttribute("data-eh") === "q-consent") {
      answers.consent = !!el.checked;
    }
  }
  root.addEventListener("input", onField);
  root.addEventListener("change", onField);

  /* ------------------------------------------------------------ submit */
  /* Email is required because the DESTINATION requires it: Shopify's contact
     form rejects a submission without contact[email], and the response is
     cross-origin, so a rejection would be invisible to us and to the viewer.
     A silently dropped lead is the worst outcome this funnel has. */
  var NEEDED = ["name", "phone", "email", "state"];

  function missing() {
    var f = answers.fields;
    for (var i = 0; i < NEEDED.length; i++) {
      if (!f[NEEDED[i]]) return NEEDED[i];
    }
    /* Shopify answers a malformed address with a 404 page, not the form, so
       catch it here while the answers are still on screen. */
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(f.email)) return "email";
    return answers.consent ? null : "consent";
  }

  function invalid() { return missing() !== null; }

  function reference() {
    var d = new Date(), p = function (n) { return String(n).padStart(2, "0"); };
    return "HE-" + String(d.getFullYear()).slice(2) + p(d.getMonth() + 1) + p(d.getDate())
         + "-" + p(Math.floor(Math.random() * 90) + 10)
         + p(Math.floor(Math.random() * 90) + 10);
  }

  function summary(ref) {
    var f = answers.fields, p = answers.picks;
    return ["EcoFlow Home Energy enquiry " + ref,
            "Name: " + (f.name || ""),
            "Phone: " + (f.phone || ""),
            f.email ? "Email: " + f.email : "",
            "State: " + (f.state || ""),
            "Interested in: " + (p.interest || "Not stated"),
            "Property: " + (p.property || "Not stated"),
            "Existing solar: " + (p.solar || "Not stated"),
            f.bill ? "Monthly bill: " + f.bill : "",
            f.note ? "Notes: " + f.note : "",
            "Contact consent: yes"].filter(Boolean).join("\n");
  }

  /* What the confirmation shows. Built from the answers on submit, and read
     back from the hand-over key after Shopify's redirect. */
  function outcome(ref) {
    var f = answers.fields, p = answers.picks;
    return { ref: ref, phone: f.phone || "", state: f.state || "", bill: f.bill || "",
             interest: p.interest || "Not stated",
             property: p.property || "Not stated",
             solar: p.solar || "Not stated" };
  }

  function fill(out) {
    var sent = panel("sent");
    if (!sent) return;
    Object.keys(out).forEach(function (k) {
      var el = sent.querySelector('[data-qout="' + k + '"]');
      if (el) el.textContent = out[k];
    });
  }

  // The design-authored validation message; failed() overwrites the slot.
  var errHTML = (root.querySelector("[data-qerr]") || {}).innerHTML || "";

  function submit() {
    var err = root.querySelector("[data-qerr]");
    if (invalid()) {
      if (err) { err.innerHTML = errHTML; err.hidden = false; }
      var bad = missing();
      var el = bad === "consent" ? root.querySelector('[data-eh="q-consent"]')
                                 : root.querySelector('[data-q="' + bad + '"]');
      if (el) el.focus();
      return;
    }
    if (err) err.hidden = true;

    var ref = reference();
    var endpoint = (root.getAttribute("data-q-endpoint") || "").trim();
    /* Where the enquiry goes. Declared in the markup rather than inferred, so
       the route can be read without tracing this file:
         email     (default)  posted to Shopify; it lands in the inbox
         whatsapp             the composed enquiry opens in WhatsApp
         both      (owner, 18OCT2026) WhatsApp AND the inbox copy
       The old rule is the fallback, so a page setting neither still works. */
    var route = (root.getAttribute("data-q-route") || "").trim()
                || (endpoint ? "email" : "whatsapp");

    /* WhatsApp FIRST, and synchronously. window.open survives a popup blocker
       only while the click that caused it is still on the stack, and postForm
       spends ~700ms arming the captcha before it navigates. */
    if (route === "whatsapp" || route === "both") handoff(ref);

    if (route === "whatsapp" || !endpoint) {
      fill(outcome(ref));
      show("sent");
      return;
    }
    if (sending) return;
    busy(true);
    postForm(endpoint, ref);
  }

  /* The button says what is happening and cannot be pressed twice while the
     captcha runs and the page posts. */
  var sending = false;
  /* Visible text goes through T(): the page's ef-i18n-js snippet fills
     window.efT with the reader's language, keyed by this English. */
  var T = function (s) { return (window.efT && window.efT[s]) || s; };
  function busy(on) {
    sending = on;
    var btn = root.querySelector('[data-eh="q-submit"]');
    if (!btn) return;
    if (on) { btn.setAttribute("data-label", btn.textContent); btn.textContent = T("Sending…"); }
    else if (btn.hasAttribute("data-label")) { btn.textContent = btn.getAttribute("data-label"); }
    btn.disabled = on;
    btn.setAttribute("aria-busy", on ? "true" : "false");
  }
  // Back from the confirmation restores this page from the bfcache, mid-send.
  window.addEventListener("pageshow", function (e) { if (e.persisted) busy(false); });

  /* The enquiry did not go. Say so, and hand over a WhatsApp link carrying
     the whole enquiry: a link the viewer presses, because a window.open from a
     timer is a popup the browser blocks. */
  function failed(ref, text) {
    var err = root.querySelector("[data-qerr]");
    if (!err) return;
    var wa = root.getAttribute("data-q-whatsapp");
    err.innerHTML = '<p class="ef-error" style="margin-top:16px"></p>';
    var p = err.firstChild;
    p.appendChild(doc.createTextNode(T("We could not send that just now. Please try again, or ")));
    if (wa) {
      var a = doc.createElement("a");
      a.href = "https://wa.me/" + wa + "?text=" + encodeURIComponent(text || summary(ref));
      a.target = "_blank";
      a.rel = "noopener";
      a.textContent = T("send it to us on WhatsApp");
      p.appendChild(a);
    } else {
      p.appendChild(doc.createTextNode(T("email info@gorental.my")));
    }
    p.appendChild(doc.createTextNode("."));
    err.hidden = false;
  }

  /* HOW AN ENQUIRY REACHES SHOPIFY — measured on the live store, 16OCT2026.
     /contact is a FORM endpoint behind hCaptcha, and it accepts exactly one
     shape of request: a real page navigation carrying h-captcha-response.
       - no token ............................ 400 "Missing CAPTCHA token"
       - token, but sent by fetch() .......... 400 "invalid parameters"
       - token, posted into a hidden iframe .. lands, but every storefront
         response is X-Frame-Options DENY, so the outcome is unreadable
     Until 16OCT2026 this file posted a token-less form into an iframe, so every
     enquiry was rejected while the page still said "Received".

     So the PAGE posts. Shopify.captcha.protect() arms the form (invisible
     hCaptcha, a challenge only when it must), then the browser navigates;
     Shopify redirects back here with ?contact_posted=true only when it
     accepted the message, and resume() shows the confirmation and records the
     ad conversion. That one fact gates both. */
  var PENDING = "ef-q-pending";

  function postForm(endpoint, ref) {
    var f = answers.fields;
    /* The confirmation's slots must survive the round trip. One key, in
       sessionStorage (this tab only), deleted the moment it is read back;
       name, email and notes are never written. If storage is unavailable the
       enquiry still goes, the confirmation just has fewer details. */
    try {
      var out = outcome(ref);
      out.at = Date.now();
      window.sessionStorage.setItem(PENDING, JSON.stringify(out));
    } catch (e) { /* private mode or storage blocked */ }

    /* The form is the one LIQUID rendered, never one built here. Shopify only
       issues a form_key and binds hCaptcha to forms it rendered itself; a
       JS-built form is answered 400 before it reaches the mailbox. */
    var form = doc.getElementById("ef-quote-contact");
    if (!form) { busy(false); failed(ref); return; }
    function put(name, value) {
      var el = form.querySelector('[name="' + name + '"]');
      if (el) el.value = value;
    }
    put("contact[name]", f.name || "");
    put("contact[email]", f.email || "");
    put("contact[phone]", f.phone || "");
    put("contact[body]", summary(ref));

    // A challenge the viewer closes never resolves: give the page back.
    setTimeout(function () {
      if (!sending) return;
      busy(false);
      try { window.sessionStorage.removeItem(PENDING); } catch (e) {}
      failed(ref);
    }, 120000);

    /* Shopify's inline captcha bootstrap listens for submit on the document
       and CANCELS any protected form that is not yet bound, then loads the
       provider. Measured 17OCT2026: without protect() it cancels and never
       recovers -- the page sits on "Sending..." forever. protect() loads the
       provider, sets data-hcaptchaBound and calls back in ~700ms; submitting
       from inside that callback is the only path that navigates.

       requestSubmit(), not submit(): submit() skips the listeners the token
       is armed on. */
    function go() {
      if (form.requestSubmit) form.requestSubmit();
      else {
        var b = doc.createElement("button");
        b.type = "submit"; b.style.display = "none";
        form.appendChild(b); b.click();
      }
    }
    var cap = window.Shopify && window.Shopify.captcha;
    if (cap && typeof cap.protect === "function") cap.protect(form, go);
    else go();   /* spam protection off: nothing to arm */
  }

  /* Back from Shopify. It redirects to this page with ?contact_posted=true
     when it accepted the message, and with ?form_type=contact alone when it
     sent it back (a captcha it would not verify, a field it refused) -- the
     second measured from a real Chrome on 16OCT2026. Either only counts with a
     hand-over written by this tab in the last ten minutes, so a shared or
     reloaded link shows nothing and records nothing. */
  function resume() {
    var params = new URLSearchParams(window.location.search);
    var posted = params.get("contact_posted") === "true";
    if (!posted && params.get("form_type") !== "contact") return;
    var out = null;
    try {
      out = JSON.parse(window.sessionStorage.getItem(PENDING) || "null");
      window.sessionStorage.removeItem(PENDING);
    } catch (e) { out = null; }
    if (!out || !out.ref || Date.now() - (out.at || 0) > 600000) return;
    params.delete("contact_posted");
    params.delete("form_type");
    var q = params.toString();
    window.history.replaceState(null, "", window.location.pathname + (q ? "?" + q : ""));
    delete out.at;
    if (posted) {
      fill(out);
      show("sent");
      convert(out.ref);
      return;
    }
    /* Rejected. The typed answers did not survive the round trip (name and
       email are never stored), so reopen the contact step with the way to a
       human, carrying what did survive. */
    step = LAST;
    show(step);
    failed(out.ref, ["EcoFlow Home Energy enquiry " + out.ref,
                     "Phone: " + out.phone, "State: " + out.state,
                     "Interested in: " + out.interest].join("\n"));
  }

  /* The Google Ads lead ("EcoFlow | Quote request"). It rides the gtag the
     Shopify Google & YouTube app already put on the page and loads nothing
     itself: no gtag on the page, no conversion. Called only after Shopify
     accepted the enquiry. The reference is the transaction_id, so a repeat of
     the same submission is counted once. */
  function convert(ref) {
    /* The ChatGPT Ads lead ("Quote request", Lead created). The OpenAI pixel in
       snippets/openai-ads.liquid defines window.oaiq; no oaiq on the page, no
       event. The reference is the event_id, so a repeat is counted once. */
    if (typeof window.oaiq === "function") {
      window.oaiq("measure", "lead_created", { type: "customer_action" }, { event_id: ref });
    }
    var sendTo = (root.getAttribute("data-q-conversion") || "").trim();
    if (!sendTo || typeof window.gtag !== "function") return;
    window.gtag("event", "conversion", { send_to: sendTo, transaction_id: ref });
  }

  /* The hand-off opens the composed enquiry in WhatsApp. A popup blocker can
     stop it, so the confirmation also carries the number — this is the path to
     a human, not a decoration. */
  function handoff(ref) {
    var wa = root.getAttribute("data-q-whatsapp");
    if (!wa) return;
    window.open("https://wa.me/" + wa + "?text=" + encodeURIComponent(summary(ref)),
                "_blank", "noopener");
  }

  function reset() {
    answers = { picks: {}, fields: {}, consent: false };
    step = 0;
    Array.prototype.forEach.call(root.querySelectorAll("[data-q]"), function (el) {
      el.value = "";
    });
    var box = root.querySelector('[data-eh="q-consent"]');
    if (box) box.checked = false;
    var err = root.querySelector("[data-qerr]");
    if (err) err.hidden = true;
    show(0);
  }

  resume();

  window.EcoFlowEnergy = window.EcoFlowEnergy || {};
  window.EcoFlowEnergy.quote = { show: show, answers: function () { return answers; } };
})();

})();
